import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import BannerSingle from '../../BannerSingle';
import Lgpd from '../../Lgpd';
import ResultadoBusca from '../../Busca';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';

class Publicacoes extends Component {

	render() {

		return (

			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>

				<ErrorBoundary><BannerSingle image={'resultado-busca'} page={'resultado-busca'} items={null}/></ErrorBoundary>
				{/* Page description */}

				{/* Content page */}
				<ErrorBoundary><ResultadoBusca /></ErrorBoundary>

				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Publicacoes;